
import { useMemo } from "react";
import { SHOPIFY_COLUMNS } from "@/lib/mapper/columns";
import { taxonomyExtraColumns } from "@/lib/mapper/taxonomy-fields";
import type { Profile } from "@/lib/mapper/types";

export function baseColumnsForProfile(profile: Profile): string[] {
  return [...SHOPIFY_COLUMNS, ...taxonomyExtraColumns(profile)];
}

export function useGridColumns(args: {
  profile: Profile;
  previewColumns: string[];
  customColumns: string[];
}): string[] {
  const { profile, previewColumns, customColumns } = args;

  return useMemo(() => {
    const base =
      previewColumns.length > 0
        ? previewColumns
        : baseColumnsForProfile(profile);
    const seen = new Set(base);
    const extras: string[] = [];
    for (const k of [...customColumns, ...Object.keys(profile.fields ?? {})]) {
      if (!seen.has(k)) {
        seen.add(k);
        extras.push(k);
      }
    }
    return extras.length ? [...base, ...extras] : base;
  }, [previewColumns, profile, customColumns]);
}
